import React from 'react';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import { GatsbyImage } from 'gatsby-plugin-image'
import './caretakers-mega-menu.scss';

const CaretakersMegaMenu = ({ subMenu }) => {

    const { homeLink } = useHomeLinkMode();
    const redirect = subMenu.redireccionDeLaOpcion

    return (
        <div className="f-m-caretakers-mega-menu">
            <div className="f-m-caretakers-mega-menu__content">
                {subMenu.opcionesSubmenu && subMenu.opcionesSubmenu.map((item, index) => (
                    <div className={"f-m-caretakers-mega-menu__col "} key={index} >

                        <a className="f-m-caretakers-mega-menu__col-title"
                            href={(homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + (redirect ? redirect : "")) + ((item.redireccionDeLaOpcion === "null") || (item.redireccionDeLaOpcion === redirect) ? "" : item.redireccionDeLaOpcion)}>
                            {item.imagenDeLaOpcion != null &&
                                <div className="f-m-caretakers-mega-menu__title-icon">
                                    <img
                                        src={item.imagenDeLaOpcion.file.url}
                                        alt={item.imagenDeLaOpcion.description}
                                    />
                                </div>}
                            {item.nombreDeLaOpcion}
                        </a>
                        <ul>
                            {item.opcionesSubmenu && item.opcionesSubmenu.map((itemSub, indexsub) => (
                                <li key={indexsub}>
                                    <a href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + redirect + (item.redireccionDeLaOpcion && item.redireccionDeLaOpcion !== "/" ? item.redireccionDeLaOpcion : "") + itemSub.redireccionDeLaOpcion}>{itemSub.nombreDeLaOpcion}</a>
                                    {itemSub.imagenDeLaOpcion != null &&
                                        <div className="f-m-caretakers-mega-menu__subOp-image">
                                            <GatsbyImage
                                                image={itemSub.imagenDeLaOpcion.gatsbyImageData}
                                                alt={itemSub.imagenDeLaOpcion.description}
                                            />
                                        </div>}
                                </li>

                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CaretakersMegaMenu;